import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { ModalProvider } from "./context/modal-context.js";
import "./index.css";
import { ThemeProvider } from "./context/theme-context.js";

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(
  <ThemeProvider>
    <ModalProvider>
      <App />
    </ModalProvider>
  </ThemeProvider>
);
